module.exports = __webpack_public_path__ + "static/img/tu.db04747.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tu.png
// module id = FV/X
// module chunks = 0